export const environment = {
  production: true,
  googlecode: '',
  apiBaseUrl: 'https://formdevisade-valorama.multinet-inside.fr/api/',
  codeApporteur: 'VALORAMA',
  primaryColor: '#FFFFFF',
  secondaryColor: '#8cc73f'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts